import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import "../../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../../shared/store/config/model/selectors/selectFilterGrid.js";
import { selectFilterGridItems } from "../../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../../shared/store/config/model/selectors/selectModels.js";
import "../../../../shared/store/config/model/selectors/selectSort.js";
import "../../../../shared/store/config/model/selectors/selectTags.js";
import "../../../../shared/store/config/model/selectors/selectTradeIn.js";
import { ConstructorWidgetEnum } from "../../../../shared/types/constructor/widget.js";
import { splitCompositeFilterPath } from "../../lib/filterPath/splitCompositeFilterPath.js";
import { FilterPathSeparatorEnum, FilterPathOperatorEnum } from "../../types/filterPath.js";
const transformFilterGridItemIntoFields = (item) => {
  const { path, field } = splitCompositeFilterPath(item.path);
  switch (item.type) {
    case ConstructorWidgetEnum.FilterLocation:
    case ConstructorWidgetEnum.FilterSelect:
    case ConstructorWidgetEnum.FilterMultipleSelect:
    case ConstructorWidgetEnum.FilterCheckboxGroup:
    case ConstructorWidgetEnum.FilterModels:
    case ConstructorWidgetEnum.FilterColorPicker:
    case ConstructorWidgetEnum.FilterDuoColorPicker: {
      const key = field ? `${item.key}${FilterPathSeparatorEnum.Operator}${FilterPathOperatorEnum.NestedField}[${field.key}=${JSON.stringify(field.value)}]` : item.key;
      return {
        [`${key}`]: `distinct(${path})`
      };
    }
    case ConstructorWidgetEnum.FilterSlider:
    case ConstructorWidgetEnum.FilterRangeSlider: {
      const { key } = item;
      return {
        [`${key}${FilterPathSeparatorEnum.Operator}${FilterPathOperatorEnum.Min}`]: `min(${path})`,
        [`${key}${FilterPathSeparatorEnum.Operator}${FilterPathOperatorEnum.Max}`]: `max(${path})`
      };
    }
    case ConstructorWidgetEnum.FilterOptions: {
      const { key } = item;
      return {
        package: "distinct(package)",
        [`${key}`]: "distinct(package.options)"
      };
    }
    default:
      return {};
  }
};
const selectFilterValuesFields = createAppSelector(selectFilterGridItems, (filterGridItems) => {
  return filterGridItems.reduce((acc, item) => {
    const fields = transformFilterGridItemIntoFields(item);
    return { ...acc, ...fields };
  }, {});
});
export {
  selectFilterValuesFields
};
